/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Vladimir Prudilin <vladimir.prudilin@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'backbone',
        'assets/js/modules/api/mailingLists',
        'assets/js/modules/utils',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min'
    ],
    function($, backbone, mailingListsApi, utils) {
        return backbone.View.extend({
            events: {
                'change #mailing-quantity': 'setQuantity',
                'change #mailing-class': 'setMailingClass'
            },

            clearQuantity: function() {
                this.model.set('quantity', 0);
            },

            setQuantity: function() {
                var newQuantity = parseInt(this.$el.find('#mailing-quantity').val()) || 0;

                if (this.model.get('maxQuantity') && newQuantity > this.model.get('maxQuantity')) {
                    newQuantity = this.model.get('maxQuantity');
                }

                this.model.set('quantity', newQuantity);
            },

            setMailingClass: function() {
                this.model.set('mailingClass', this.$el.find('#mailing-class').val());
            },

            initialize: function(options) {
                this.$el.find('#mailing-class').selectBoxIt();

                this.listenTo(this.model, 'change:itemId change:quantity change:mailingClass', this.calculatePrice);
                this.listenTo(this.model, 'change:availableMailingClasses', this.renderMailingClass);
                this.listenTo(this.model, 'change:price', this.renderPrice);
                this.listenTo(this.model, 'change:quantity', this.renderQuantity);
            },

            calculatePrice: function() {
                var self = this;
                if (!this.model.get('mailingClass') || !this.model.get('itemId')) {
                    return;
                }

                mailingListsApi
                    .getPrice()
                    .once('success', function(data) {
                        self.model.set('currency', data.currency);
                        self.model.set('price', data.price);
                        self.model.set('mailingClass', data.mailingClass);
                        self.model.set('availableMailingClasses', data.availableMailingClasses);
                    })
                    .start({
                        mailingClass: self.model.get('mailingClass'),
                        itemId: self.model.get('itemId'),
                        quantity: self.model.get('quantity')
                    });
            },

            renderMailingClass: function() {
                var $mailingClassSelectBox = this.$el.find('#mailing-class').data('selectBox-selectBoxIt');
                if ($mailingClassSelectBox === undefined) {
                    return;
                }
                $mailingClassSelectBox.remove();

                $.each(this.model.get('availableMailingClasses'), function(key, value) {
                    var mailingClassesNames = {
                        first: 'First Class Letter Rate',
                        standard: 'Standard Bulk Rate'
                    };
                    $mailingClassSelectBox.add({
                        value: value,
                        text: mailingClassesNames[value],
                        'data-text': mailingClassesNames[value]
                    });
                });

                $mailingClassSelectBox.selectOption(this.model.get('mailingClass'));

                if (this.model.get('availableMailingClasses').length == 1) {
                    $mailingClassSelectBox.disable();
                } else {
                    $mailingClassSelectBox.enable();
                }
            },

            renderPrice: function() {
                var price = utils.formatPrice(this.model.get('price'), this.model.get('currency'));
                this.$el.find('#mailing-price').text(price);
            },

            renderQuantity: function() {
                this.$el.find('#mailing-quantity').val(this.model.get('quantity'));
            },

            resizeMailingClass: function() {
                var width = this.$el.find('#mailing-class-container').width();
                this.$el.find('#mailing-class').css('width', width);
            },

            hide: function(withSliding) {
                if (withSliding) {
                    this.$el.slideUp();
                } else {
                    this.$el.hide();
                }
            },

            show: function(withSliding) {
                if (withSliding) {
                    this.$el.slideDown();
                } else {
                    this.$el.show();
                }
            }
        });
    }
);
